import { CanActivateFn } from '@angular/router';
import { environment } from '@env';
import { AuthenticationType } from '../models/authentication-type.enum';
import { azureAdAuthGuard } from './aad-auth.guard';
import { azureB2cAuthGuard } from './b2c-auth.guard';
import { basicAuthGuard } from './basic-auth.guard';

export const authGuard: CanActivateFn = (route, state) => {
  switch (environment.authenticationType) {
    case AuthenticationType.Anonymous:
    case AuthenticationType.ActiveDirectory:
      return basicAuthGuard(route, state);
    case AuthenticationType.AzureActiveDirectory:
      return azureAdAuthGuard(route, state);
    case AuthenticationType.AzureB2C:
      return azureB2cAuthGuard(route, state);
  }
};
